module.exports = __webpack_public_path__ + "static/media/roundaboutCW225.74c0aa39.svg";